import { defineMessages } from 'react-intl';

const messages = defineMessages({
  onboardTitle: {
    description: 'onboarding title',
    defaultMessage: 'Welcome to ShipStation',
    id: 'G+8g48',
  },
  onboardSubTitle: {
    description: 'onboarding subtitle',
    defaultMessage: 'Check out our <a>Quickstart Guide</a> or take a guided approach with <cta>ShipStation University</cta>.',
    id: 'QPz8Pg',
  },
  onboardHideMessage: {
    description: 'onboarding settings cta',
    defaultMessage: 'Hide this onboarding guide',
    id: '6szN6N',
  },
  onboardFooterMessage: {
    description: 'onboarding footer message',
    defaultMessage:
      'All options are also configurable in <link>Settings</link>, and you can access Quickstart and ShipStation University from the <a>Help Center</a>.',
    id: 'rqIFNL',
  },
  hideConfirmationModalHeader: {
    description: "header for the modal used to confirm with the user that they'd like to hide the onboard page",
    defaultMessage: 'Hide Onboarding Guide',
    id: 'VkJl14',
  },
  hideConfirmationBodyHeader: {
    description: 'h4 in modal body to call user to action',
    defaultMessage: 'Are you sure you want to hide the onboarding guide?',
    id: '1ffAbh',
  },
  hideConfirmationBody: {
    description: 'description in the body of the modal of what the user is confirming',
    defaultMessage:
      'You can configure any of these options at any time in your account <linkAndIcon>Settings</linkAndIcon> as well as show this onboarding guide again, if desired.',
    id: 'O78ezM',
  },
  hideConfirmButton: {
    description: 'button to confirm hiding of the onboarding page',
    defaultMessage: 'Continue',
    id: 'XVg95y',
  },
  cancelHideOnboarding: {
    description: 'button to cancel hiding of onboard',
    defaultMessage: 'Cancel',
    id: 'mHBHE6',
  },
  completed: {
    description: 'A message to inform the user they have complete an action within the onboarding page',
    defaultMessage: '{icon} Completed',
    id: 'P3+4OM',
  },
  connect: {
    description: 'Button to open marketplace connection modal',
    defaultMessage: 'Connect',
    id: 'F1vVln',
  },
  connected: {
    description: 'Button to connected existing connected store. This button takes user to store settings',
    defaultMessage: 'Connected',
    id: '2w6f5o',
  },
  errorTitle: {
    description: 'Title for a notification that happens when trying to save the seller setting.',
    defaultMessage: 'ShipStation could not save your changes.',
    id: 'C/rguC',
  },
  errorContent: {
    description: 'Description for a notification that happens when trying to save the seller setting.',
    defaultMessage: 'You may not have the correct permissions. Please try again or contact your account administrator.',
    id: 'xfelxN',
  },
  carouselHeader: {
    description: 'Header for the carousel of add-ons',
    defaultMessage: 'Explore Add-On Features',
    id: '+n5kZo',
  },
  linkToAddOns: {
    description: 'Link to add-ons marketplace',
    defaultMessage: 'View all Add-Ons',
    id: 'PeVHIy',
  },
  seeMore: {
    description: 'link to see all add-ons',
    defaultMessage: 'Want to see more?',
    id: 'BXQ6Ob',
  },
  checkItOut: {
    description: 'link to add-ons marketplace',
    defaultMessage: 'Check it out',
    id: 'tqnify',
  },
  includedInHighVolume: {
    description: 'message to inform user that add-on is included in high volume plan',
    defaultMessage: 'Included in the High Volume plan',
    id: 'giFUxa',
  },
});

export default messages;
